<template>
	<DialogFrom :width="'1000px'" :title="title" :dialogVisible="dialogVisible" @cancel="cancel" @dialogOK="save">
		<div class="activity-dialog">
			<!-- Form -->
			<div class="form-container" v-if="!(userInfo && userInfo.IsSalesDepartment === 1)">
				<template v-for="(item, index) in formConfig">
					<Commondropdownlist :ref="'formRef'" :key="index" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :options="item.options" :disabled="item.disabled"
						@change="(val) => handleFormChange(val, index)">
					</Commondropdownlist>
				</template>
			</div>

			<!-- Table Section -->
			<div class="table-section" style="margin-top: 20px;">
				<div class="btn-group" style="margin-bottom: 10px;">
					<Commonbtn v-if="!(userInfo && userInfo.IsSalesDepartment === 1)" backgroundColor="#FFF" title="新增医院" fontSize="14px" @btnclick="addHospital"
						:src="require('@/assets/icon/icon-add.png')">
					</Commonbtn>
					<Commonbtn v-if="!(userInfo && userInfo.IsSalesDepartment === 1)" backgroundColor="#FFF" title="删除医院" fontSize="14px" @btnclick="deleteHospital"
						:src="require('@/assets/icon/icon-del.png')">
					</Commonbtn>
				</div>

				<div class="table-container">
					<el-table :data="DetailsInput" border style="width: 100%" height="300px"
						@selection-change="handleSelectionChange"
						:header-cell-style="{ background: '#F0F2F5', color: '#333' }">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column label="医院" width="220">
							<template slot-scope="scope">
								<el-select v-model="scope.row.hospital" filterable remote
									:remote-method="remoteMethodHospital" placeholder="请输入关键词"
									@change="(val) => handleHospitalChange(val, scope.row)" size="small"
									style="width: 100%" :disabled="userInfo && userInfo.IsSalesDepartment === 1">
									<el-option v-for="(item,index) in hospitalOptions" :key="index" :label="item.value"
										:value="item.key">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="ProvinceName" label="省份" width="100"></el-table-column>
						<el-table-column prop="HosGradeName" label="医院等级" width="100"></el-table-column>
						<el-table-column label="科室" width="120">
							<template slot-scope="scope">
								<el-input v-model="scope.row.technicalOffices" size="small"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="术者" width="100">
							<template slot-scope="scope">
								<el-input v-model="scope.row.doctor" size="small"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="术者职称" width="100">
							<template slot-scope="scope">
								<el-input v-model="scope.row.doctorTitle" size="small"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="手术量" width="100">
							<template slot-scope="scope">
								<el-input v-model="scope.row.surgeryCountPerYear" size="small"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="重点产品" width="150">
							<template slot-scope="scope">
								<el-select v-model="scope.row.level3Code" size="small" :disabled="userInfo && userInfo.IsSalesDepartment === 1">
									<el-option v-for="(item,index) in level3Options" :key="index" :label="item.text"
										:value="item.value">
									</el-option>
								</el-select>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</DialogFrom>
</template>

<script>
	import DialogFrom from "@/components/dialog-from.vue";
	import Commondropdownlist from "@/components/common-dropdownlist.vue";
	import Commonbtn from "@/components/common-btn.vue";
	import {
		ActivityRecordAdd,
		ActivityInfo,
		HelperLEVEL2ForItem,
		HelperInHospitalStatus,
		HelperLEVEL3ForItem,
		HelperActivityPurpos
	} from "@/api/ActivityList";
	import {
		InventoryClassList,
		HospitalList,
		HospitalInfo
	} from "@/api/home";

	export default {
		components: {
			DialogFrom,
			Commondropdownlist,
			Commonbtn
		},
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: "活动举办"
			}
		},
		data() {
			return {
				formConfig: [{
						title: "活动名称",
						inputtype: "input",
						inputdata: "",
						width: "180px",
						lablewith: "100px",
						placeholder: "请输入",
						fontSize: "14px",
						color: "#333333",
						disabled: true
					},
					{
						title: "会议类型",
						inputtype: "selectMultiple",
						inputdata: [],
						width: "180px",
						lablewith: "100px",
						options: [],
						placeholder: "请选择",
						fontSize: "14px",
						color: "#333333"
					},
					{
						title: "活动时间",
						inputtype: "dates",
						inputdata: "",
						width: "180px",
						lablewith: "100px",
						placeholder: "请选择",
						fontSize: "14px",
						color: "#333333"
					},
					{
						title: "活动目标",
						inputtype: "select",
						inputdata: "",
						width: "190px",
						lablewith: "100px",
						options: [],
						placeholder: "请选择",
						fontSize: "14px",
						color: "#333333"
					}
				],
				DetailsInput: [],
				hospitalOptions: [],
				level3Options: [],
				inHospitalStatusOptions: [],
				selection: [],
				currentId: null,
				currentInvClass: null,
				originalData: null
			};
		},
		computed: {
			userInfo() {
				return this.$store.state.MenusData;
			}
		},
		methods: {
			async init(id) {
				this.reset();
				this.currentId = id;
				await this.getOptions();
				await this.getInfo(id);
			},
			reset() {
				if (this.$refs.formRef) {
					this.$refs.formRef.forEach((item, index) => {
						if (index === 1) item.modelvalue = [];
						else item.modelvalue = "";
					});
				}
				this.DetailsInput = [];
				this.selection = [];
				this.currentInvClass = null;
			},
			async getOptions() {
				// InHospitalStatus
				let res2 = await HelperInHospitalStatus({});
				if (res2.code == 0) {
					this.inHospitalStatusOptions = res2.data.map(item => ({
						text: item.Text,
						value: item.Value
					}));
				}
				// Activity Purpose
				let res3 = await HelperActivityPurpos({});
				if (res3.code == 0) {
					this.formConfig[3].options = res3.data.map(item => ({
						key: item.Value,
						value: item.Text
					}));
				}
			},
			async handleInvClassChange(val) {
				if (!val) return;
				// Get L2 (Meeting Type)
				let resL2 = await HelperLEVEL2ForItem({
					InvClass: val
				});
				if (resL2.code == 0) {
					this.formConfig[1].options = resL2.data.map(it => ({
						key: it.Value,
						value: it.Text
					}));
				}
				// Get L3 (Key Product)
				let resL3 = await HelperLEVEL3ForItem({
					InvClass: val
				});
				if (resL3.code == 0) {
					this.level3Options = resL3.data.map(it => ({
						value: it.Value,
						text: it.Text
					}));
				}
			},
			async remoteMethodHospital(query) {
				if (query !== '') {
					let res = await HospitalList({
						hpName: query,
						HosType: "医院"
					});
					if (res.code == 0) {
						const newOptions = res.data.data.map(item => ({
							key: item.HPID,
							value: item.HPName
						}));
						const existingKeys = new Set(newOptions.map(o => o.key));
						const preservedOptions = this.hospitalOptions.filter(o => !existingKeys.has(o.key));
						this.hospitalOptions = [...newOptions, ...preservedOptions];
					}
				}
			},
			async handleHospitalChange(val, row) {
				let res = await HospitalInfo({
					hpid: val
				});
				if (res.code == 0) {
					this.$set(row, 'ProvinceName', res.data.ProvinceName);
					this.$set(row, 'HosGradeName', res.data.HosGradeName);
				}
			},
			addHospital() {
				this.DetailsInput.push({
					AHPDCode: '',
					hospital: null,
					ProvinceName: '',
					HosGradeName: '',
					technicalOffices: '',
					doctor: '',
					doctorTitle: '',
					surgeryCountPerYear: '',
					level3Code: ''
				});
			},
			deleteHospital() {
				if (this.selection.length === 0) {
					this.$message.warning('请选择要删除的医院');
					return;
				}
				this.DetailsInput = this.DetailsInput.filter(item => !this.selection.includes(item));
			},
			handleSelectionChange(val) {
				this.selection = val;
			},
			async getInfo(id) {
				let res = await ActivityInfo({
					ActivityCode: id
				});
				if (res.code == 0) {
					let d = res.data;
					this.originalData = d;
					this.currentInvClass = d.InvClass;

					await this.handleInvClassChange(d.InvClass);

					this.$nextTick(() => {
						if (this.$refs.formRef) {
							if (this.$refs.formRef[0]) this.$refs.formRef[0].modelvalue = d.ActivityName;
							if (this.$refs.formRef[1]) this.$refs.formRef[1].modelvalue = d.lstLEVEL2.map(item => item.Level2Code);
							if (this.$refs.formRef[2]) this.$refs.formRef[2].modelvalue = d.PreConductDate ? d.PreConductDate.split('T')[
								0] : '';
							if (this.$refs.formRef[3]) this.$refs.formRef[3].modelvalue = d.Purpose || '';
						}
					});

					this.DetailsInput = d.DetailsOutPut.map(item => ({
						AHPDCode: item.AHPDCode,
						hospital: item.Hospital,
						HospitalName: item.HospitalName,
						ProvinceName: item.ProvinceName,
						HosGradeName: item.HosGradeName,
						technicalOffices: item.TechnicalOffices,
						doctor: item.Doctor,
						doctorTitle: item.DoctorTitle,
						surgeryCountPerYear: item.SurgeryCountPerYear,
						inHospitalStatus: item.InHospitalStatus,
						level3Code: item.Level3Code,
						salesAmountPerMonth: item.SalesAmountPerMonth
					}));

					this.hospitalOptions = d.DetailsOutPut.map(item => ({
						key: item.Hospital,
						value: item.HospitalName
					}));
				}
			},
			async save() {
				await this.submitData();
			},
			async submitData(IsForce = undefined) {
				let data = {
					ActivityCode: this.currentId,
					ActivityName: this.$refs.formRef && this.$refs.formRef[0] ? this.$refs.formRef[0].modelvalue : (this.originalData ? this.originalData.ActivityName : ''),
					InvClass: this.currentInvClass,
					PreConductDate: this.$refs.formRef && this.$refs.formRef[2] ? this.$refs.formRef[2].modelvalue : (this.originalData && this.originalData.PreConductDate ? this.originalData.PreConductDate.split('T')[0] : ''),
					lstLEVEL2: this.$refs.formRef && this.$refs.formRef[1] ? this.$refs.formRef[1].modelvalue : (this.originalData && this.originalData.lstLEVEL2 ? this.originalData.lstLEVEL2.map(item => item.Level2Code) : []),
					Purpose: this.$refs.formRef && this.$refs.formRef[3] ? this.$refs.formRef[3].modelvalue : (this.originalData ? this.originalData.Purpose : ''),
					DetailsInput: this.DetailsInput.map(item => ({
						AHPDCode: item.AHPDCode,
						hospital: item.hospital,
						technicalOffices: item.technicalOffices,
						doctor: item.doctor,
						doctorTitle: item.doctorTitle,
						surgeryCountPerYear: item.surgeryCountPerYear,
						inHospitalStatus: item.inHospitalStatus,
						level3Code: item.level3Code,
						salesAmountPerMonth: Number(item.salesAmountPerMonth)
					}))
				};

				if (IsForce !== undefined) {
					data.IsForce = IsForce;
				}

				let res = await ActivityRecordAdd(data);
				if (res.code == 0) {
					this.$message.success('举办成功');
					this.$emit('dialogOK');
					this.$router.push('/homeCom/ActivityRecord?MenuID=1095&NodeID=1093');
				} else if (res.code == 300) {
					const message = res.message || '';
					const dataList = Array.isArray(res.data) ? res.data : [];
					const html = `<strong>${message}</strong><br/>${dataList.join(',<br/>')}`;

					this.$confirm(html, '提示', {
						dangerouslyUseHTMLString: true,
						confirmButtonText: '是',
						cancelButtonText: '否',
						distinguishCancelAndClose: true,
						type: 'warning'
					}).then(() => {
						this.submitData(1);
					}).catch(action => {
						if (action === 'cancel') {
							this.submitData(0);
						}
					});
				} else {
					this.$message.error(res.message);
				}
			},
			handleFormChange(val, index) {
				// Placeholder if needed
			},
			cancel() {
				this.$emit('cancel');
			}
		}
	};
</script>

<style scoped>
	.activity-dialog {
		padding: 10px;
	}

	.form-container {
		display: flex;
		flex-wrap: wrap;
		/* gap: 10px; */
	}

	.table-container {
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #FFFFFF;
	}

	/* 统一表格内输入框样式 */
	/deep/ .el-table .el-input__inner,
	/deep/ .el-table .el-select .el-input__inner {
		border-radius: 4px;
		border-color: #DCDFE6;
		height: 32px;
		line-height: 32px;
	}

	/deep/ .el-table .el-input__inner:focus,
	/deep/ .el-table .el-select .el-input__inner:focus {
		border-color: #409EFF;
	}
</style>